<script>
    // import app from "../../stores/app";
    import R, {LOADER} from "../../lib/requests";
    import Notifier from "../../stores/notifier";
    import AppIcon from "../../components/icons/AppIcon.svelte";
    import {setFocusTo} from "../../lib/lib";

    export let pageId = null;
    export let onCloseHandler;

    let page = null;

    const initialize = () => {

        if (!pageId) {
            page = {
                id: 0,
                parentId: 0,
                code: '',
                name: '',
                title: '',
                description: ''
            };
        } else {
            load();
        }
    }

    const load = () => {
        const onSuccess = result => {
            page = result;
        }

        const onFailure = err => {
        };

        R.handle(R.page.details, pageId, onSuccess, onFailure, LOADER.POPUP);
    }

    const save = () => {
        const onSuccess = result => {
            page.id = result.id;
            Notifier.showMessage("Η σελίδα ενημερώθηκε");
            onCloseHandler(result);
        }

        const onFailure = err => {
        };

        page.title = page.title.trim();
        if (!page.title) {
            Notifier.showError("Πληκτρολογήστε τον τίτλο της σελίδας");
            setFocusTo("pageTitle");
            return;
        }

        let action = pageId == 0 ? 'create' : 'edit';
        R.handle(R.page[action], page, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = () => {
        onCloseHandler();
    }

    initialize();
</script>

{#if page}
    <div class="panel panel-default">
        <div class="panel-heading">
            Σελίδα
            <button class="btn btn-danger btn-xs" on:click={ close }>
                <AppIcon icon="x" size="16" strokeWidth="2"/>
            </button>
        </div>
        <div class="panel-body panel-pad">
            <div class="form-group">
                <label class="label-sm">Όνομα</label>
                <input type="text" class="form-control" id="pageName" bind:value="{ page.name }"/>
            </div>
            <div class="form-group">
                <label class="label-sm">Κωδικός</label>
                <input type="text" class="form-control" bind:value="{ page.code }"/>
            </div>
            <hr>
            <div class="form-group">
                <input type="text" class="form-control" bind:value={ page.title } placeholder="τίτλος">
            </div>
            <div class="form-group">
                <textarea class="form-control" bind:value={ page.description } placeholder="περιγραφή"></textarea>
            </div>
            <hr>
            <div class="text-end">
                <button class="btn btn-link me-4" on:click={ close }>Κλείσιμο</button>
                <button class="btn btn-primary" on:click={ save }>ΕΝΗΜΕΡΩΣΗ</button>
            </div>
        </div>
    </div>
{/if}